// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@steiner/Overrides/Widgets/AccountSettings/AccountSettingsHeader";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

headerStyles.container = {
    offsetCss: css`
        align-items: baseline;
    `,
    css: css`
        margin-bottom: 30px;

        ${xScreen("lte", "sm")} {
            margin-bottom: 16px;
        }
    `,
};

headerStyles.titleWrapper = {
    width: [12, 6, 6, 6, 6],
};

headerStyles.title = {
    variant: "h1",
    css: css`
        margin-bottom: 0;
    `,
};

headerStyles.buttonSet = {
    width: [12, 6, 6, 6, 6],
    css: css`
        gap: 10px;
        justify-content: flex-end;
        ${xScreen("lte", "xs")} {
            flex-direction: column-reverse;
        }
    `,
};

headerStyles.cancelButton = {
    variant: "tertiary",
    css: css`
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

headerStyles.saveButton = {
    css: css`
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

headerStyles.errorMessageNotificationWrapper = {
    width: 12,
};

headerStyles.errorMessageNotification = {
    css: css`
        margin: 0;
    `,
};
